/**
 * Bảng mã trạng thái / mã lỗi gửi tin ZNS - SMS.
 *
 * Lưu ý về cột `dlvr_status`: cột này trộn HAI không gian mã.
 *  - Mã không âm (0..3) là trạng thái BÁO CÁO GIAO tin -> DLVR_REPORT
 *  - Mã âm (-100..-147) là errcode của API GỬI TIN ZNS  -> ZNS_ERROR
 * Nên phải dán nhãn qua dlvrLabel(), không tra một bảng phẳng.
 *
 * Cột `code` KHÔNG phải mã Zalo mà là errcode của gateway trung gian
 * (vẫn trả 0 dù ZNS lỗi) -> GATEWAY_CODE.
 *
 * Bản đối chiếu phía backend: one_pay/Modules/Log/Support/ZnsErrorCode.php
 * Sửa bảng ở đây thì sửa cả file kia.
 *
 * @see https://developers.zalo.me/docs/zbs-template-message/bang-ma-loi
 */

/** Trạng thái báo cáo giao tin ZNS (dlvr_status không âm). */
export const DLVR_REPORT = {
    "0": "Zalo chưa gửi được cho khách hàng",
    "1": "Gửi thành công xuống máy khách hàng",
    "2": "Không tìm thấy referentId",
    "3": "Gửi lặp",
};

/** Mã lỗi API gửi tin ZNS qua số điện thoại (dlvr_status âm). */
export const ZNS_ERROR = {
    "-100": "Phát sinh lỗi không xác định",
    "-101": "Ứng dụng gửi ZNS không hợp lệ",
    "-102": "Ứng dụng gửi ZNS không tồn tại",
    "-103": "Ứng dụng gửi ZNS chưa được phê duyệt",
    "-104": "Mã secret key không tồn tại",
    "-105": "Ứng dụng gửi ZNS chưa liên kết với OA",
    "-106": "Phương thức không được hỗ trợ",
    "-107": "ID ZNS không hợp lệ",
    "-108": "Số điện thoại không hợp lệ",
    "-109": "ID mẫu ZNS không hợp lệ",
    "-110": "Người dùng chưa cập nhật Zalo phiên bản mới",
    "-111": "Mẫu ZNS không có dữ liệu",
    "-112": "Dữ liệu mẫu ZNS không hợp lệ",
    "-113": "Nút không hợp lệ",
    "-114": "Người dùng không nhận được ZNS vì nhiều lý do",
    "-115": "Ví không đủ số dư",
    "-116": "Nội dung không hợp lệ",
    "-117": "OA hoặc ứng dụng chưa được cấp quyền sử dụng mẫu ZNS",
    "-118": "Số điện thoại chưa đăng ký Zalo hoặc người dùng đã vô hiệu hóa tài khoản",
    "-119": "Tài khoản không thể nhận ZNS",
    "-120": "OA chưa được cấp quyền sử dụng tính năng này",
    "-121": "Mẫu ZNS không có nội dung",
    "-122": "Nội dung mẫu ZNS không đúng định dạng json",
    "-123": "Không giải mã được nội dung mẫu ZNS",
    "-124": "Mã truy cập không hợp lệ",
    "-125": "ID OA không hợp lệ",
    "-126": "Ví (development mode) không đủ số dư",
    "-127": "Template test chỉ có thể được gửi cho admin",
    "-128": "Ứng dụng gửi ZNS chưa có mã encoding",
    "-129": "Mã encoding không thể được tạo ra",
    "-130": "Nội dung mẫu ZNS vượt giới hạn kí tự",
    "-131": "Mẫu ZNS chưa được phê duyệt",
    "-132": "Tham số không hợp lệ",
    "-133": "Không hỗ trợ gửi ZNS trong khung giờ 22h - 6h",
    "-134": "Người dùng chưa phản hồi gợi ý nhận ZNS từ OA",
    "-135": "OA chưa được cấp quyền gửi ZNS",
    "-136": "Ứng dụng cần kết nối với ZBA để sử dụng tính năng trả phí",
    "-137": "ZBA kết nối không đủ số dư hoặc không thể thanh toán",
    "-138": "Ứng dụng gửi ZNS chưa có quyền sử dụng tính năng này",
    "-139": "Người dùng đã từ chối nhận loại ZNS này",
    "-140": "OA chưa được cấp quyền gửi ZNS hậu mãi cho người dùng",
    "-141": "Người dùng từ chối nhận ZNS từ OA",
    "-142": "OA chưa có RSA key, vui lòng gọi API tạo RSA key",
    "-143": "OA đã có RSA key, vui lòng gọi API get RSA key",
    "-144": "OA đã vượt quá số lượng gửi cho phép trong ngày hôm nay",
    "-145": "OA không được phép gửi loại nội dung ZNS này",
    "-146": "Mẫu ZNS này đã bị vô hiệu hóa do chất lượng thấp",
    "-147": "OA đã vượt quá số lượng gửi cho phép của mẫu ZNS này",
};

/**
 * Mã lỗi API tin OA (đợt thu CAMPAIGN đi đường này) - không gian mã khác hẳn
 * ZNS gửi qua SĐT, đừng trộn hai bảng.
 */
export const ZNS_CAMPAIGN = {
    "0": "Success - Request thành công",
    "-32": "Ứng dụng vượt quá giới hạn tốc độ request/phút",
    "-100": "attachment_id đã hết hạn - cần upload lại",
    "-200": "Gửi tin nhắn thất bại",
    "-201": "Tham số không hợp lệ",
    "-204": "Official Account đã bị xóa",
    "-205": "Official Account không tồn tại",
    "-209": "API không được hỗ trợ do ứng dụng chưa kích hoạt",
    "-210": "Tham số vượt quá giới hạn cho phép",
    "-211": "Vượt quá quota sử dụng tính năng",
    "-212": "OA chưa đăng ký API này",
    "-213": "Người dùng chưa quan tâm OA",
    "-214": "Bài viết đang được xử lý - thử lại sau",
    "-216": "Access token không hợp lệ",
    "-217": "Người dùng đã chặn OA",
    "-218": "Vượt quá giới hạn gửi đến người dùng này",
    "-219": "Ứng dụng bị gỡ hoặc vô hiệu hóa",
    "-220": "Access token hết hạn hoặc không khả dụng",
    "-221": "OA chưa xác thực",
    "-223": "OA chưa cấp quyền API hoặc đã vượt quota tạo bài viết",
    "-224": "OA chưa mua gói dịch vụ để dùng tính năng này",
    "-227": "User bị khóa hoặc không online hơn 45 ngày",
    "-230": "User không tương tác với OA trong 7 ngày qua",
    "-232": "User chưa tương tác hoặc tương tác đã hết hạn",
    "-233": "Loại tin nhắn không hợp lệ hoặc không hỗ trợ",
    "-234": "Không được gửi loại tin này từ 22:00 - 06:00",
    "-235": "API không hỗ trợ cho loại OA hiện tại",
    "-237": "Nhóm chat đã hết hạn",
    "-238": "asset_id đã dùng hoặc không khả dụng",
    "-240": "API V2 đã dừng - cần chuyển sang API Message V3",
    "-241": "asset_id miễn phí đã được dùng",
    "-242": "appsecret_proof không hợp lệ",
    "-244": "User hạn chế nhận loại tin này từ OA",
    "-248": "Nội dung vi phạm tiêu chuẩn nền tảng",
    "-320": "App cần kết nối với Zalo Cloud Account (ZCA)",
    "-321": "ZCA hết tiền hoặc không thể thanh toán",
    "-403": "OA không thuộc nhóm chat này",
    "-1340": "Không tìm thấy form",
    "-1341": "OA không có quyền truy cập form",
};

/** Trạng thái báo cáo giao tin SMS. */
export const SMS_DLVR = {
    "0": "Gửi tin thất bại",
    "1": "Gửi tin thành công",
};

/** Errcode của gateway trung gian (cột `code`), dùng chung ZNS/SMS. */
export const GATEWAY_CODE = {
    "0": "Success",
    "1": "Lỗi hệ thống",
    "2": "Dữ liệu vào không hợp lệ",
    "3": "Sai username hoặc password",
    "4": "Tài khoản chưa kích hoạt",
    "5": "Số điện thoại không hợp lệ",
    "6": "Phone send sms is loop (đã gửi)",
    "7": "Tài khoản không đủ quota (hết tiền)",
    "8": "Brandname chưa được kích hoạt cho tài khoản",
    "9": "Brandname chưa được kích hoạt bởi nhà mạng",
    "10": "Nhà mạng không khớp",
    "11": "Không tìm thấy IP",
    "13": "Unicode chỉ nhận 0 hoặc 1",
};

/** Mã lỗi do phía người nhận - nhóm phường cần để rà soát lại hộ dân. */
const RECIPIENT_DLVR = ["-118", "-108", "-110", "-141", "-139", "-114", "-119", "-134"];

/** Mã lỗi phía mình hay gặp, đưa lên dropdown cho tiện tra. */
const SYSTEM_DLVR = ["-144", "-147", "-131", "-117", "-135", "-115"];

/**
 * Giá trị cho bộ lọc `error_reason`, backend parse theo tiền tố:
 *  `group:<key>` nhóm ngữ nghĩa | `dlvr:<mã>` mã Zalo | `code:<mã>` mã gateway.
 * Nhóm "Lỗi phía hệ thống" cố ý tách riêng: đó là lỗi OA/gateway của mình,
 * không phải lỗi của dân, gộp vào là phường đi truy oan.
 */
export const ERROR_REASON_OPTIONS = [
    {
        label: "Nhóm nhanh",
        options: [
            { value: "group:no_zalo", label: "Số chưa đăng ký Zalo" },
            { value: "group:bad_phone", label: "Số điện thoại không hợp lệ" },
            { value: "group:recipient", label: "Không tới được do SĐT / Zalo khách" },
            { value: "group:system", label: "Lỗi phía hệ thống / OA" },
        ],
    },
    {
        label: "Lỗi phía khách (mã Zalo)",
        options: RECIPIENT_DLVR.map((code) => ({
            value: `dlvr:${code}`,
            label: `${code} - ${ZNS_ERROR[code]}`,
        })),
    },
    {
        label: "Lỗi phía hệ thống (mã Zalo)",
        options: SYSTEM_DLVR.map((code) => ({
            value: `dlvr:${code}`,
            label: `${code} - ${ZNS_ERROR[code]}`,
        })),
    },
    {
        label: "Mã gateway",
        options: ["5", "1", "7"].map((code) => ({
            value: `code:${code}`,
            label: `${code} - ${GATEWAY_CODE[code]}`,
        })),
    },
];

/** Phân loại bản ghi để biết tra bảng mã nào. */
export const getCategory = (record) => {
    if (record?.type !== "ZNS") return "SMS";

    return record?.customer_fee?.collection?.type === "FIXED" ? "ZNS_FIXED" : "ZNS_CAMPAIGN";
};

/**
 * Nhãn cho `dlvr_status`. Với ZNS cố định thì tự chọn bảng theo dấu của mã.
 * Trả null nếu không tra được -> caller nên fallback sang `receive_result`.
 */
export const dlvrLabel = (dlvrStatus, category = "ZNS_FIXED") => {
    const code = String(dlvrStatus ?? "");
    if (code === "") return null;

    if (category === "SMS") return SMS_DLVR[code] ?? null;
    if (category === "ZNS_CAMPAIGN") return ZNS_CAMPAIGN[code] ?? null;

    return code.startsWith("-") ? ZNS_ERROR[code] ?? null : DLVR_REPORT[code] ?? null;
};

/** Nhãn cho errcode gateway (cột `code`). */
export const gatewayLabel = (code) => {
    const key = String(code ?? "");

    return key === "" ? null : GATEWAY_CODE[key] ?? null;
};

/** Màu cho "Chi tiết trạng thái", tô theo ngữ cảnh từng loại tin. */
export const getDetailColor = (category, code) => {
    const s = String(code);

    if (category === "SMS") return s === "1" ? "#128555" : "#E5065C";

    if (category === "ZNS_CAMPAIGN") {
        if (s === "0") return "#128555";
        if (s.startsWith("-")) return "#E5065C";
        return "#475569";
    }

    // ZNS_FIXED
    if (s === "1") return "#128555";
    if (s === "0") return "#A8681E";
    if (s === "2" || s === "3") return "#0070D7";
    if (s.startsWith("-")) return "#E5065C";
    return "#475569";
};
